var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(-579 -1847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    transform: "translate(579 1847)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "money_3_",
    "data-name": "money (3)",
    transform: "translate(585.715 1851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M32.219,53.816V48.962c-.116-.1-.245-.179-.355-.289L14.525,31.044c-.9-.776,1.448.747,2.312.327l6.78,1.566L44.5,53.816Zm13.56,0H62.048V47.09a11.122,11.122,0,0,0,3.629-13.171Z",
    transform: "translate(4.441 15.146)",
    fill: "#fac176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M30.594,0,5.285,25.311,18.994,39.02a5.183,5.183,0,0,1,3.5-1.377H37.406a5.22,5.22,0,0,1,0,10.44h-9.35L49.577,69.6,74.888,44.294Z",
    transform: "translate(0)",
    fill: "#e8e8d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 35.794,
    height: 16.406,
    transform: "translate(33.677 68.962)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M48.185,62.645H24.322V46.239H38.38a9.8,9.8,0,0,1,9.8,9.8Z",
    transform: "translate(9.355 22.723)",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 3.729,
    cy: 3.729,
    r: 3.729,
    transform: "translate(44.117 73.436)",
    fill: "#556080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M34.49,13.235a5.216,5.216,0,1,0-6.87-6.87Z",
    transform: "translate(10.976 1.592)",
    fill: "#fac176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M39.49,18.235a5.216,5.216,0,1,0-6.87-6.87Z",
    transform: "translate(13.433 4.049)",
    fill: "#fac176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M44.49,23.235a5.216,5.216,0,1,0-6.87-6.87Z",
    transform: "translate(15.89 6.506)",
    fill: "#fac176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M49.49,28.235a5.216,5.216,0,1,0-6.87-6.87Z",
    transform: "translate(18.347 8.963)",
    fill: "#fac176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M33.456,35.679H18.542a5.235,5.235,0,0,1-5.22-5.22h0a5.235,5.235,0,0,1,5.22-5.22H33.456a5.235,5.235,0,0,1,5.22,5.22h0A5.235,5.235,0,0,1,33.456,35.679Z",
    transform: "translate(3.95 12.403)",
    fill: "#fdd7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M37.8,15.64a1.49,1.49,0,0,1-2.109,0l-3.269-3.269a7.619,7.619,0,0,1-8.227,0l-6.538,6.54a7.483,7.483,0,0,1,0,8.225l3.269,3.269a1.491,1.491,0,1,1-2.109,2.109l-5.272-5.272L14.6,26.187a4.482,4.482,0,0,0,0-6.328L13.542,18.8,24.088,8.259l1.054,1.054a4.583,4.583,0,0,0,6.328,0l1.054-1.054L37.8,13.533A1.489,1.489,0,0,1,37.8,15.64ZM62.054,37.786l-5.272-5.272a1.491,1.491,0,1,0-2.109,2.109l3.269,3.269a7.483,7.483,0,0,0,0,8.225L51.4,52.657a7.613,7.613,0,0,0-8.227,0l-3.269-3.269A1.491,1.491,0,0,0,37.8,51.5l5.274,5.274,1.054-1.054a4.583,4.583,0,0,1,6.328,0l1.054,1.054L62.056,46.225,61,45.17a4.482,4.482,0,0,1,0-6.328Zm3.163,3.163a1.491,1.491,0,1,0,0,2.109A1.49,1.49,0,0,0,65.217,40.949ZM46.234,57.823a1.491,1.491,0,1,0,2.109,0A1.49,1.49,0,0,0,46.234,57.823ZM29.362,7.2a1.491,1.491,0,1,0-2.109,0A1.49,1.49,0,0,0,29.362,7.2ZM10.379,21.967a1.491,1.491,0,1,0,2.109,0A1.49,1.49,0,0,0,10.379,21.967Z",
    transform: "translate(2.288 2.288)",
    fill: "#6d8c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M42.53,18.267A13.416,13.416,0,0,0,19.929,30.6H30.357a5.206,5.206,0,0,1,.488,10.391A13.414,13.414,0,0,0,42.53,18.267Z",
    transform: "translate(7.047 7.044)",
    fill: "#6d8c60"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA4);
export default __webpack_public_path__ + "static/media/a4.79498b1a629482f596786ef6444b3e6b.svg";
export { ForwardRef as ReactComponent };